<div class="row" fxLayout.gt-xs="row" fxLayoutGap="" fxLayoutGap.gt-xs="1.5ch">
  <ng-content></ng-content>
</div>
